module.exports = __webpack_public_path__ + "@/assets/img/zoom-plus.819ebd05.svg";